export default __webpack_public_path__ + "static/media/img1.e391bea7.png";